import { connect } from 'react-redux';
import { M_CALL_SIP_TRUNK } from '../../../common/v5/constants';
import {
	changeAdminView
	, toggleAdminEdit
	, setAdminInput
	, resetAdminInput
	, setSipTrunkMatch
	, adminActionStatus
} from '../../../redux/actions/admin';
//
import {
	getAdminListSelector
	, listColumnSelector
} from '../../../redux/selectors/admin';
import {
	fetchAdminList,
	sstAsyncs
} from '../../../redux/actions/async/admin';
import {
	togglePopWaiting
	, clearPopWaiting
	, popErrorOnly
} from '../../../redux/actions/hmf'
import { pleaseWaitString } from '../../../common/v5/helpers';
import { TXT_FETCHING_DATA} from '../../../common/v5/chatbotConstants'
import  SipTrunk from './siptrunks';

const mapSipTrunkState = (store, props) => {
    const server = store.server
		, app = store.app
		, admin = app.admin
		, ui = admin.ui
		, adminSt = admin.admin
		, wf = app.workflow
		;
	return {
		view: ui.view,
		list: getAdminListSelector(store),
		langSrc: adminSt.langSrc,
		order: listColumnSelector(store),
		show: adminSt.show,
		showInline: adminSt.showInline,
		showList: adminSt.showList,
		activeId: adminSt.activeId,
		input: adminSt.input,
		filter: adminSt.filter,
		adminStatus: adminSt.adminStatus
	};
};

const mapSipTrunkAction = (dispatch, props) => {
	return {
		onLoad: (view, freshLoad) => {
			dispatch(changeAdminView(view));
		},
		onLoadToEdit: (id, view, popout, list) => {
			dispatch(resetAdminInput());
			dispatch(toggleAdminEdit(0, false, false, true));
			dispatch(togglePopWaiting(pleaseWaitString(TXT_FETCHING_DATA)));
			dispatch(sstAsyncs[M_CALL_SIP_TRUNK].one(id))
				.then((rs) => {
					dispatch(clearPopWaiting());
					dispatch(toggleAdminEdit(id, true, false, true));
				})
				.catch(err => {
					console.log("error getting records:", err);
					dispatch(clearPopWaiting());
					return dispatch(popErrorOnly(err));
				})
		},
		onChangeAdminInput: (field, value, key) => {
			dispatch(setAdminInput(field, value, key));
		},
		onSaveAdmin: (params, view, popout, list) => {
			dispatch(adminActionStatus({ status: 1, msg: I("Pending") }));
			dispatch(sstAsyncs[M_CALL_SIP_TRUNK].save(params))
			.then((rs) => {
				if(typeof rs.status !== 'undefined'){
					if(rs.status == "success"){
						dispatch(toggleAdminEdit(0, false, false, true));
						dispatch(fetchAdminList(M_CALL_SIP_TRUNK));
						dispatch(adminActionStatus({ status: 2, msg: I("Finished") }));
					} else {
						if(typeof rs.message !== 'undefined' &&
							rs.message != ""){
							dispatch(popErrorOnly(rs.message));
							dispatch(adminActionStatus({ status: 3, msg: rs.message }));
						} else {
							dispatch(popErrorOnly(I("Error updating sip trunk")));
							dispatch(adminActionStatus({ status: 3, msg: I("Error updating sip trunk") }));
						}
					}
				}
			})
		},
		onDeleteFromList: (id, view, popout, list) => {
			dispatch(sstAsyncs[M_CALL_SIP_TRUNK].remove(id))
			.then((rs) => {
				dispatch(fetchAdminList(M_CALL_SIP_TRUNK));
				dispatch(toggleAdminEdit(0, false, false, true));
				dispatch(clearPopWaiting());
				dispatch(fetchAdminList(M_CALL_SIP_TRUNK));
			})
			.catch(err => {
				console.log("error deleting contact :", err)
				dispatch(clearPopWaiting());
				return dispatch(popErrorOnly(err));
			});
		},
		onSetMatch: (field, value, isRemove) => {
			dispatch(setSipTrunkMatch(field, value, isRemove));
		},
		onCloseForm: (id, view, popout, list) => {
			dispatch(resetAdminInput());
			dispatch(toggleAdminEdit(0, false, false, true));
		}
	}
};

const SipTrunkCtnr = connect(
	mapSipTrunkState
	, mapSipTrunkAction
)(SipTrunk);

export default SipTrunkCtnr;
